import React from 'react'



export class Locations extends React.PureComponent {
    state = { src: 'https://maps.google.com/maps?q=emiel%20van%20dorenlaan%20144&t=&z=13&ie=UTF8&iwloc=&output=embed' };

    handleClickButton = event => {
        this.setState({ src: 'https://maps.google.com/maps?q=emiel%20van%20dorenlaan%20144&t=&z=13&ie=UTF8&iwloc=&output=embed' });
      };
      handleClickButton_B = event => {
        this.setState({ src: 'https://maps.google.com/maps?q=Rijksweg%20390b%20Maasmechelen&t=&z=13&ie=UTF8&iwloc=&output=embed' });
      };

    render() {
        return (
            <section id="location">
            <div className="location d-flex justify-content-center align-items-center">
                <h2 className="text-white">Location</h2>
            </div>
            
                <div id="map" className="m-0 p-0">
            <iframe title="google maps" src={this.state.src} width="100%" height="620" frameborder="0" style={{border:0}} allowfullscreen=""></iframe>
            </div>
                <button onClick={this.handleClickButton} className="ButtonGoogleMaps border-right">Sportcentrum - Emiel Van Dorenlaan 144</button>
                <button onClick={this.handleClickButton_B} className="ButtonGoogleMaps">Spartan Gym - Rijksweg 390b</button>
    

        </section>
        )
    }
}

export default React.memo(Locations)
